/**
 * Deletes a cookie by its name.
 * @param name - The name of the cookie to retrieve.
 * @returns void
 */
export function deleteCookie(name: string) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
